import { Component, OnInit, ViewChild, Inject, Directive, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ValidationErrors } from '@angular/forms';
import { Login } from '@models/login-dto';
import { ServiceLogin } from '@services/ServiceLogin';
import { ModalsComponent } from '../../notifications/modals.component';
import { MustMatch } from '../../../helpers/must-match.validator';
import { Router } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService, StorageService } from 'angular-webstorage-service';
import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { global } from '../../../_nav';
declare var jQuery: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})


export class LoginComponent implements OnInit {
  @ViewChild(ModalsComponent) public modales: ModalsComponent;

  public modelo: Login;
  loginFormulario: FormGroup;
  router: Router;
  public loading = false;
  public _menu: string;
  public submitted = false;
  public data: any = []
  public empresaLogin: any = [];
  public empresaMod: any = [];
  public empresa: boolean=true;
  public elem;
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, public localstorage: LocalStorageService,
    _router: Router, private formBuilder: FormBuilder, private servicio: ServiceLogin, private globalVar: global) {
    this.router = _router;
    this.nuevo();

  }
  ngOnInit() {
    this.loginFormulario = this.formBuilder.group({
      ruc: ['', Validators.required],
      usuario: ['', Validators.required],
      clave: ['', [Validators.required, Validators.minLength(6)]]
    }, {
        validator: MustMatch('clave', 'clave')
      });
  }

  cargarMenu(menuPerfilCab, menuPerfilDet) {
    localStorage.removeItem("menu");
    var cabeceraMenu = [];
    var det = {
      name: '',
      url: '',
      icon: ''
    };
    det.name = 'Pricipal';
    det.url = '/seguridad/principal';
    det.icon = 'icon-speedometer';
    cabeceraMenu.push(det);
    for (var i = 0; i < menuPerfilCab.length; i++) {
      var detCab = {
        name: '',
        url: '',
        icon: '',
        children: []
      };
      detCab.name = menuPerfilCab[i].grupo_pag;
      detCab.url = '/' + menuPerfilCab[i].grupo_pag;
      detCab.icon = menuPerfilCab[i].icono_gru_pag;
      detCab.children = [];
      for (var j = 0; j < menuPerfilDet.length; j++) {
        if (menuPerfilCab[i].grupo_pagh === menuPerfilDet[j].grupo_pag) {
          var detD = {
            name: menuPerfilDet[j].nombre_pag,
            url: '/' + menuPerfilDet[j].grupo_pag + '/' + menuPerfilDet[j].link_pag,
            icon: menuPerfilDet[j].grafico_pag
          }
          detCab.children.push(detD);
        }
      }
      cabeceraMenu.push(detCab);
    }
    this._menu = JSON.stringify(cabeceraMenu);
    localStorage.setItem("menu", this._menu);
    this.globalVar.cambioMenu(this._menu);

    
  }

  empresaLoginVisual() {
    var emp = [];
    emp = this.storage.get("EMPRESA");
    if (emp.length == 1) {
      this.router.navigate(['/seguridad/principal']);
    } else {
      this.empresa = false;
    }
  }

  recuperar() {
    this.router.navigate(['/loginReset']);
  }


  loginPerfilUsuaio(empresaMod) {
    this.modelo.CodPorv = empresaMod;
    this.loading = true;
    this.servicio.getLoginPerfil(this.modelo).subscribe((results) => {
      try {
        if (results.codError.toString() === "0") {
          this.loading = false;
          this.servicio.setUsuarioLoginIn(true);
          localStorage.setItem("listamenu", JSON.stringify(results.root[1]));
          this.cargarMenu(results.root[0], results.root[1]);
        } else {
          this.loading = false;
          this.modales.dangermodal(results.msgError.toString());
          this.ngOnInit();
        }
      } catch (e) {
        this.loading = false;
        this.ngOnInit();
      }
    }, err => {
      this.loading = false;
    });
  }

  isValideCompleteForm(){
    if(this.loginFormulario.controls.ruc.getError('required') ||
    this.loginFormulario.controls.usuario.getError('required')  ||
    this.loginFormulario.controls.clave.getError('required')  )
      return false;
    return true;
  }

  isValidePasssForm(){
    if(!this.loginFormulario.controls.clave.valid)
      return false;
    return true;
  }

    loginUsuaio() {
      debugger;
      if (!this.isValideCompleteForm()) {
        this.modales.dangermodal("Por favor completar los campos necesarios.");
        return;
      }
    if (!this.isValidePasssForm()) {
      this.modales.dangermodal("La contraseña no cumple con el formato establecido.");
      return;
    }

    this.loading = true;
    this.servicio.getLogin(this.modelo).subscribe((results) => {
      try {
        if (results.codError.toString() === "0") {
          this.storage.set("USRID", this.modelo.Usuario);
          this.storage.set("USUARIO", results.root[0]);
          this.storage.set("AUTORIZA", true);
          this.storage.set("TOKEN", "Bearer " + results.root[3]);
          this.storage.set("AD", results.root[4]);
          this.storage.set("CONFIGURACION", results.root[6]);
          if (results.root[5].length == 1) {
            this.storage.set("EMPRESA", results.root[5]);
          } else {
            this.storage.set("EMPRESA", results.root[5]);
            this.empresaLogin = [];
            for (var i = 0; i < results.root[5].length; i++) {
              var item = {
                emp_codigo: results.root[5][i].emp_codigo,
                emp_nombre_empresa: results.root[5][i].emp_nombre_empresa
              };
              this.empresaLogin.push(item);
            }
            
          }
          this.loading = false;
          this.servicio.setUsuarioLoginIn(true);
          localStorage.setItem("listamenu", JSON.stringify(results.root[2]));
          this.cargarMenu(results.root[1], results.root[2]);
          this.empresaLoginVisual();
          //this.cargarMenu(results.root[1], results.root[2]);
        } else {
          this.loading = false;
          this.modales.dangermodal(results.msgError.toString());
          this.ngOnInit();
        }
      } catch (e) {
        this.loading = false;
        this.ngOnInit();
      }
    }, err => {
      this.loading = false;
    });
  }
  cargar() {
 this.loading = true;
    if (this.empresaMod.length == 0) {
      this.modales.dangermodal("Por favor debe seleccionar una empresa.");
    this.loading = false;
      return;
    } else {
      var emp = [];
      emp = this.storage.get("EMPRESA");
      var empArray = [];
      for (var i = 0; i < emp.length; i++) {
        if (emp[i].emp_codigo == this.empresaMod) {
          empArray.push(emp[i]);
          this.storage.set("EMPRESA", empArray );
          this.router.navigate(['/seguridad/principal']);
        }
        };
      
      
    }
    
  }
  cancelar() {
    this.empresa = true;
    this.modelo.Ruc = "";
    this.modelo.Usuario = "";
    this.modelo.Clave = "";
    this.empresaMod = [];
    this.empresaLogin = [];
  }

  nuevo() {
    this.localstorage.clear();
    this.storage.remove("USUARIO");
    this.storage.remove("AUTORIZA");
    this.storage.remove("TOKEN");
    this.storage.remove("AD");
    this.storage.remove("EMPRESA");
    this.storage.remove("USRID");
    this.storage.remove("ProveeParametro");
    this.modelo = new Login();
  }
  get f() { return this.loginFormulario.controls; }


  onReset() {
    this.loginFormulario.reset();
  }

}
